<!--
*   val : 需要传过来的普通按钮
* isprice: 1 显示价格选择器
* isCalendar: 1 显示日期选择器
* isDistrict: 1 显示区域选择器
-->
<template>
  <div id="mySizer" class="mySizer">
    <ul>
      <li
        v-for="(item, index) in val"
        :key="item"
        :class=" active == item ? 'active': ''"
        @click="onclick(item,index)"
      >
        <!-- <router-link to> -->
        <slot :name="item" />
        <!-- </router-link> -->
        <div v-if="(slotItem[index].hasArrow && slotItem[index].sales) ? (slotItem[index].hasArrow && slotItem[index].sales): ''" class="button">
          <svg-icon
            v-if="buttonType == 'top'"
            :icon-class="buttonType === 'top' && active == item ? 'sales3': 'sales1'"
          />
          <!-- @click="topButton(item,'top')" -->
          <svg-icon
            v-if="buttonType == 'bottom' || buttonType == ''"
            :icon-class="buttonType === 'bottom' && active == item ? 'sales2': 'sales1'"
          />
          <!-- @click="topButton(item,'bottom')" -->
        </div>
        <div v-if="(slotItem[index].hasArrow && !slotItem[index].sales) ? (slotItem[index].hasArrow && !slotItem[index].sales): ''" class="button">
          <svg-icon
            class="topSvg"
            :icon-class="buttonType === 'top' && active == item ? 'shang-white': 'shang-hui'"
          />
          <!-- @click="topButton(item,'top')" -->
          <svg-icon
            :icon-class="buttonType === 'bottom' && active == item ? 'xia-white': 'xia-hui'"
          />
          <!-- @click="topButton(item,'bottom')" -->
        </div>
      </li>
      <!-- 价格选择器 -->
      <li v-if="isprice == 1" :class="onPrice ? 'price2' : 'price'">
        <el-input v-model="minPrice" placeholder="最低价" @focus="price()" />
        <div class="line" />
        <el-input v-model="maxPrice" placeholder="最高价" @focus="price()" />
        <div v-show="onPrice" class="priceButton" @click="priceButton()">确定</div>
      </li>
      <!-- 日期选择器 -->
      <li v-if="isCalendar == 1" :class="onCalendar ? 'calendar2' : 'calendar'">
        <el-date-picker
          v-model="startDate"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          @clear="clearDate"
          @focus="calendar()"
        />
        <div class="line" />
        <el-date-picker
          v-model="endDate"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
          @clear="clearDate"
          @focus="calendar()"
        />

        <div v-show="onCalendar" class="priceButton" @click="calendarButton">确定</div>
      </li>
      <!-- 区域选择 -->
      <li v-if="isDistrict == 1" style="width:160px;" class="district" :class=" district !== '区域选择' ? 'active' : ''">
        <slot>{{ district }}</slot>
        <div class="button" @click="onDistrict()">
          <svg-icon
            :icon-class="isDistrictShow && district !== '区域选择' ? 'shang-red' : isDistrictShow ? 'shang-hui' : district !== '区域选择' ? 'xia-red': 'xia-hui'"
          />
        </div>
        <div />
        <div v-if="isDistrictShow == '1'" class="districtBox">
          <div class="oncancel" @click="oncancel()">取消选择</div>

          <!-- <span v-for="(item,index) in city.hotCity" :key="index" class="city" @click="chooseCity(item)">{{ item }}</span> -->
          <div class="line" />
          <span
            v-for="(cityName, key) in city.cityItem"
            :key="key+'sds'"
            class="city"
            @click="chooseCity(cityName)"
          >{{ cityName.FName }}</span>
          <div class="searchCity">
            <input v-model="cityInput" class="cityInput" placeholder="请输入要查找的城市">
            <div class="confirm" @click="onConfirm()">确定</div>
          </div>
        </div>
      </li>
      <!-- 实地考察 -->
      <li v-if="isField == 1">
        <el-checkbox v-model="checked" @change="lookNow">实地考察</el-checkbox>
      </li>
      <li v-if="isFormat == 1" class="show-format">
        <span :class="!format ? 'selectText' : ''" @click="changeFormat(0)">
          <svg-icon
            :icon-class="'list' + format"
          />
          列表
        </span>
        <span :class="format ? 'selectText' : ''" @click="changeFormat(1)">
          <svg-icon
            :icon-class="'big' + format"
          />
          大图
        </span>
      </li>
      <li v-if="isTotal == 1" class="total">
        共<span style="font-weight:bold;">{{ total }}</span>件商品
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'MySizer',
  props: {
    val: {
      type: Number,
      required: true,
      default: 0
    },
    isprice: {
      type: Number,
      // required: true
      default: 0
    },
    isCalendar: {
      type: Number,
      default: 0
    },
    isDistrict: {
      type: Number,
      default: 0
    },
    isField: {
      type: Number,
      default: 0
    },
    isTotal: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    isFormat: {
      type: Number,
      default: 0
    },
    // 每个插槽的上下箭头是否展示
    // slotItem: [
    //     {},
    //     { hasArrow: true },
    //     { hasArrow: true }
    //   ]
    // 默认不加，加的时候传true
    slotItem: {
      type: Array,
      default: () => {
        return []
      }
    },
    city: {
      type: Object,
      default: () => {
        return {
          hotCity: [],
          cityItem: []
        }
      }
    }
  },
  data() {
    return {
      format: 1,
      active: 1, // 选中的按钮
      buttonType: '', // 选中的上下按钮
      minPrice: '', // 最低价
      maxPrice: '', // 最高价
      startDate: '', // 开始时间
      endDate: '', // 结束时间
      onPrice: false, // 价格选择器的确定按钮默认不显示
      onCalendar: false, // 日期选择器的确定按钮默认不显示
      district: '区域选择', // 区域显示
      cityInput: '', // 输入要查找的城市
      isDistrictShow: false, // 区域选择的显示隐藏
      checked: false // 实地考察
      // city: {
      //   hotCity: ['北京', '上海', ' 杭州', '广州', '深圳'],
      //   cityItem: ['北京', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门']
      // }
    }
  },
  methods: {
    changeFormat(val) {
      this.format = val
      this.$emit('changeFormat', val)
    },
    clearDate() {},
    onclick(item, index) {
      const n = this.active == item
      this.active = item
      if (this.slotItem[index].hasArrow) {
        const value = n ? (!this.buttonType ? 'top' : this.buttonType == 'top' ? 'bottom' : 'top') : 'top'
        this.active = item
        this.buttonType = value
        var sizerData = {
          type: item,
          buttonType: value
        }
        this.$emit('onScreen', sizerData)
      } else {
        this.buttonType = ''
        this.$emit('onActive', item, this.buttonType)
      }
    },
    topButton(item) {
      const value = this.buttonType ? 'top' : this.buttonType == 'top' ? 'bottom' : 'top'
      this.active = item
      this.buttonType = value
      var sizerData = {
        type: item,
        buttonType: value
      }
      this.$emit('onScreen', sizerData)
    },
    // 点击最高价或最低价获取焦点 显示确定按钮
    price() {
      this.onPrice = true
    },
    priceButton() {
      let i = true
      if (this.minPrice !== '' && this.maxPrice !== '') {
        if (Number(this.minPrice) > Number(this.maxPrice)) {
          i = false
        }
      }
      if (i) {
        var price = {
          minPrice: this.minPrice,
          maxPrice: this.maxPrice
        }
        this.$emit('onPrice', price)
        this.onPrice = false
      } else {
        this.$message.error('最小价格不能大于最大价格')
      }
    },
    // 点击日期选择器获取焦点 显示确定按钮
    calendar() {
      this.onCalendar = true
    },
    // 选择开始时间和结束时间点击确定按钮
    calendarButton() {
      const data1 = new Date(this.startDate).getTime()
      const data2 = new Date(this.endDate).getTime()
      if (data2 < data1) {
        return this.$message.error('结束日期不能小于开始日期')
      }
      var calendar = {
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$emit('onCalendar', calendar)
      this.onCalendar = false
    },
    // 点击了区域选择
    onDistrict() {
      this.isDistrictShow = !this.isDistrictShow
    },
    // 取消选择
    oncancel() {
      // this.isDistrictShow = false
      this.district = '区域选择'
    },
    // 点击城市选择
    chooseCity(item) {
      this.district = item.FName
      this.$emit('onCity', {
        type: 1,
        code: item.FTreeCode
      })
      this.isDistrictShow = false
      this.cityInput = ''
      // this.isDistrictShow = false
    },
    // 实地考察
    lookNow(val) {
      this.$emit('lookUp', val)
    },
    // 城市选择点击了确定
    onConfirm() {
      if (this.cityInput !== '') {
        this.district = this.cityInput
      }
      this.$emit('onDistrict', this.district)
      this.isDistrictShow = false
      this.cityInput = ''
    }
  }
}
</script>
<style lang="scss" scoped>
#mySizer {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border: 1px solid #d2d2d2;
  box-sizing: border-box;
  margin-top: 20px;
}
#mySizer ul {
  display: flex;
  position: relative;
}
#mySizer li {
    caret-color: transparent;
  width: 100px;
  font-size: 14px;
  color: #999;
  border-right: 1px solid #d2d2d2;
  text-align: center;
  line-height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

}
#mySizer .total {
    font-size: 16px;
    width: 150px;
    position: absolute;
    right: 0;
    border-right: 0;
        // font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
        // text-rendering: optimizeLegibility;
        // -webkit-font-smoothing: antialiased;
    span {
        color: #ec212d;
    }
}
#mySizer .show-format {
    position: absolute;
    right: 150px;
    width: 150px;
    justify-content: left;
    .svg-icon {
        margin: 0 5px;
    }
    :last-child {
        margin-left: 10px;
    }
    .selectText {
        color: #ec212d;
    }
}
#mySizer .price {
  width: 181px;
}
#mySizer .price2 {
  width: 243px;
}
.district {
  position: relative;
}
.districtBox {
  z-index: 99999;
  width: 400px;
  height: 326px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  position: absolute;
  top: 36px;
  left: -1px;
  padding: 20px;
  text-align: left;
  line-height: 24px;
  .oncancel {
    width: 72px;
    height: 24px;
    background: #ec212d;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;
    color: #fff;
    font-size: 12px;
    margin-bottom: 18px;
  }
  .city {
    display: inline-block;
    font-size: 12px;
    color: #666;
    padding: 0 9px;
    &:hover {
      color: red;
      cursor: pointer;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: #000000;
    opacity: 0.1;
    margin: 12px 0;
  }
  .searchCity {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .cityInput {
      width: 256px;
      height: 28px;
      line-height: 28px;
      border: 1px solid #d2d2d2;
      padding: 0 10px;
      font-size: 12px;
      color: #999;
    }
    .confirm {
      width: 52px;
      height: 24px;
      background: #ec212d;
      border-radius: 4px;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      color: #fff;
    }
  }
}
.priceButton {
  width: 52px;
  height: 24px;
  background: #ec212d;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  margin: 0 10px;
}
.line {
  width: 9px;
  height: 1px;
  background-color: #999;
  margin: 0 12px;
}
#mySizer .calendar {
  width: 303px;
}
#mySizer .calendar2 {
  width: 365px;
}
#mySizer li {
    cursor: pointer;
}
#mySizer li .button {
  display: inline-block;
  padding-left: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#mySizer li .button .topSvg {
  margin-bottom: -6px;
}
.active {
  background: #ec2631;
  color: #fff !important;
}
</style>
<style lang="scss">
#mySizer {
    li {
        .el-input__inner {
            caret-color: #000;
        }
    }
  .el-date-editor .el-icon-circle-close {
    margin-top: -2px;
  }
  .el-input {
    width: 64px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 120px;
  }
  .el-input .el-input__inner {
    width: 64px;
    height: 26px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: unset;
    padding: 0 10px;
  }
  .el-input--prefix .el-input__inner {
    width: 120px;
    height: 26px;
    border-radius: unset;
    padding: 0 10px;
  }
  .el-date-editor {
    .el-input__prefix {
      left: initial;
      right: 15px;
      top: -2px;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
</style>
